export default __webpack_public_path__ + "static/media/german.ccd87166.jpg";